// extracted by mini-css-extract-plugin
export default {"calendar-event-modal":"styles_calendar-event-modal__HR+21","detail-link":"styles_detail-link__n8+YV"};